import { GButton, GConfirm } from 'components/basic-blocks'
import { useStores } from 'hooks'
import { ReactElement } from 'react'
import { useUiStore } from 'store'
import { useTrackPostHogEvent } from '../../../../../utils/posthog'
import { PostHogEvent, PostHogPath } from '../../../../../utils/posthog-events'
import { useShallow } from 'zustand/react/shallow'

export const RevertCancelling = ({
	posthogEvent = PostHogEvent.CANCEL_RETURN,
	posthogPath = PostHogPath.SETTINGS_BILLING,
	posthogProperties = null,
	buttonLabelClassName,
	trigger
}: {
	posthogEvent?: string
	posthogPath?: string
	posthogProperties?: Record<string, any> | null
	buttonLabelClassName?: string
	/** Replaces the default button — the billing card supplies a DS AppButton. */
	trigger?: ReactElement
}) => {
	const { accountStore } = useStores()
	const { uiActionState } = useUiStore(
		useShallow((s) => ({
			uiActionState: s.uiActionState
		}))
	)
	const loading = uiActionState['ACCOUNT_SAVE_SUBSCRIPTION'] === 'loading'
	const trackPostHogEvent = useTrackPostHogEvent()
	const { account, getSubscriptionByAccountId, revertChange } = accountStore
	const payload = { note: 'User manually reverted subscription change' }
	const handleRevertCancellation = async () => {
		if (!account?.billing?.subscription?.id) return
		trackPostHogEvent(posthogEvent, posthogPath, posthogProperties)
		await revertChange(account!.id, payload)
		await getSubscriptionByAccountId(account!.id)
	}
	return (
		<GConfirm
			type="warning"
			title="Keep subscription"
			description="You will keep your subscription and revert scheduled cancellation. Proceed?"
			onConfirm={() => handleRevertCancellation()}
			loading={loading}
			closeModalOnConfirm
		>
			{trigger ?? (
				<GButton
					label="Resume plan"
					variant="contained"
					color="yellow"
					className="rounded-lg"
					labelClassName={buttonLabelClassName}
				/>
			)}
		</GConfirm>
	)
}
